import { render } from "./assets-details.vue?vue&type=template&id=81de733a&scoped=true"
import script from "./assets-details.vue?vue&type=script&lang=js"
export * from "./assets-details.vue?vue&type=script&lang=js"

import "./assets-details.vue?vue&type=style&index=0&id=81de733a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81de733a"]])

export default __exports__